"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { Doughnut, Chart as ChartJS } from 'react-chartjs-2';

// eslint-disable-next-line no-unused-vars
const DoughnutChart = _ref => {
  let {
    colors,
    data: chartData,
    legendKey,
    totalKey
  } = _ref;
  return (
    /*#__PURE__*/
    // const options = {
    //   responsive: true,
    //   legend: {
    //     display: true,
    //     position: 'right',
    //     labels: {
    //       usePointStyle: true,
    //       pointStyle: 'circle',
    //     },
    //     generateLabels: (chart) => {
    //       const dataset = chart.data.datasets[0];
    //       const meta = chart.getDatasetMeta(0);
    //       const { total } = meta;
    //       const legendItems =
    //         ChartJS.controllers.doughnut.overrides.plugins.legend.labels.generateLabels(chart);
    //       return legendItems.map((item) => {
    //         const legendItem = JSON.stringify(item);
    //         const value = dataset.data[legendItem.index];
    //         const percentage = (value / total) * 100;
    //         legendItem.text = `${legendItem.text}: ${value} / ${percentage.toFixed(0)}%`;
    //         return legendItem;
    //       });
    //     },
    //   },
    //   cutoutPercentage: 80,
    //   tooltips: {
    //     callbacks: {
    //       label: (tooltipItem, data) => {
    //         const dataset = data.datasets[tooltipItem.datasetIndex];
    //         const { _meta } = dataset;
    //         const meta = _meta[Object.keys(_meta)[0]];
    //         const { total } = meta;
    //         const currentValue = dataset.data[tooltipItem.index];
    //         const percentage = parseFloat(((currentValue / total) * 100).toFixed(1));
    //         return `${currentValue} (${percentage}%)`;
    //       },
    //       title: (tooltipItem, data) => data.labels[tooltipItem[0].index],
    //     },
    //   },
    // };
    // const graphData = chartData.reduce((acc, el) => {
    //   const key = el[legendKey];
    //   if (acc[key]) {
    //     acc[key] += el[totalKey];
    //   } else {
    //     acc[key] = el[totalKey];
    //   }
    //   return acc;
    // }, {});
    // const data = {
    //   labels: Object.keys(graphData),
    //   datasets: [
    //     {
    //       label: '',
    //       data: Object.values(graphData),
    //       backgroundColor: colors,
    //     },
    //   ],
    // };
    // return <Doughnut data={data} options={options} />;
    _react.default.createElement(_react.Fragment, null)
  );
};
DoughnutChart.propTypes = {
  data: _propTypes.default.array,
  colors: _propTypes.default.array,
  legendKey: _propTypes.default.string,
  totalKey: _propTypes.default.string
};
DoughnutChart.defaultProps = {
  data: [],
  colors: ['#FCB040', '#9BB08E', '#9F2020', '#DA5C05', '#76B900', '#EBB600', '#8F7156', '#587993', '#995409', '#5998C9', '#762938', '#8D9150', '#616A74', '#00457C', '#F1B12E', '#D63F2E', '#98C27C'],
  legendKey: '',
  totalKey: ''
};
var _default = exports.default = DoughnutChart;
//# sourceMappingURL=DoughnutChart.js.map